module.exports = __webpack_public_path__ + "assets/img/ADVANCED_LOGIC_PLUGIN.89d1e212.svg";